export const EVENT_GRACE_PERIOD = 1000 * 60 * 15;
export const NEXT_EVENT_INQUIRE_INTERVAL = 60000;
export const ALERT_INQUIRE_INTERVAL = 10000;
